import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual';

export default class HierarchyDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data });
    }
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.data, this.state.data) ||
           nextProps.disabled !== this.props.disabled;
  }

  render() {
    const { data, disabled, ...rest } = this.props;

    return (
      <div
        style={{
          color: disabled ? '#6c759d' : '',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          borderRadius: '4px'
        }}
      >
        <DropdownTreeSelect data={this.state.data} {...rest} />
      </div>
    );
  }
}
